const store = require.context("./Store", true);
store.keys().forEach(key => store(key));
if (module.hot) {
    module.hot.accept(store.id, () => onHotWidgetReplace(require.context("./Store", true)));
}

const services = require.context("./Services", true);
if (module.hot) {
    module.hot.accept(services.id, () => onHotWidgetReplace(require.context("./Services", true)));
}

const widgets = require.context("./Widgets", true, /\.tsx$/);
const onHotWidgetReplace = addWidgetsFromContext(widgets);
// ensure HMR works for custom widgets
if (module.hot) {
    module.hot.accept(widgets.id, () => onHotWidgetReplace(require.context("./Widgets", true, /\.tsx$/)));
}

// Load all handlers so they are included in the bundle.
// Recursively get all handler modifications
const handlers = require.context("./Handlers", true);
// Load the handler modifications.
handlers.keys().forEach(key => handlers(key));
if (module.hot) {
    module.hot.accept(handlers.id, () => onHotWidgetReplace(require.context("./Handlers", true)));
}

// Load all the extensions to the base widgets. This includes style extensions.
const widgetExtensions = require.context("./WidgetExtensions", true);
widgetExtensions.keys().forEach(key => widgetExtensions(key));

import { addPagesFromContext, addWidgetsFromContext } from "@insite/client-framework/Components/ContentItemStore";
// load all pages. Without this they won't be included in the bundle
const pages = require.context("./Pages", true, /\.tsx$/);
const onHotPageReplace = addPagesFromContext(pages);

// ensure HMR works for custom pages
if (module.hot) {
    module.hot.accept(widgets.id, () => onHotPageReplace(require.context("./Pages", true, /\.tsx$/)));
}

import { setPostStyleGuideTheme, setPreStyleGuideTheme } from "@insite/client-framework/ThemeConfiguration";
import { css } from "styled-components";

setPreStyleGuideTheme({
    colors: {
        primary: {
            main: "#191919",
        },
        secondary: {
            main: "#CD2037",
        },
        text: {
            accent: "#005696",
        },
    },
    globalStyle: {
        css: css`
            .accent-background::before {
                content: "";
                background: #cd2037;
                position: absolute;
                display: block;
                width: 60px;
                left: 0;
                height: 35px;
                transform: skew(130deg);
                -ms-transform: skew(130deg);
                -webkit-transform: skew(130deg);
            }
            span {
                word-break: normal !important;
            }
            button {
                white-space: normal !important;
            }
            button:focus, a:focus {
                outline-color: #CD2037 !important;
            }
        `,
    },
    typography: {
        fontFamilyImportUrl:
            "https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap",
    },
});

setPostStyleGuideTheme({
    breakpoints: {
        keys: ["xs", "sm", "md", "lg", "xl"],
        values: [0, 576, 768, 950, 1441],
        maxWidths: [540, 540, 768, 1300, 1700],
    },
    globalStyle: {
        css: css`
            input[type="text"]:focus, input[type="number"]:focus, input[type="password"]:focus,
            textarea:focus, select:focus {
                font-size: 16px;
            }
        `,
    },
});
